import PropTypes from "prop-types";
import React from "react";

import { AnimatePresence, motion } from "framer-motion";

import FnrEnrichedCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

ShareCheckbox.propTypes = {
  share: PropTypes.bool,
  setShare: PropTypes.func,
  showShareCheckbox: PropTypes.bool,
  makeReport: PropTypes.bool,
};

export default function ShareCheckbox({
  share,
  setShare,
  showShareCheckbox = false,
  makeReport,
}) {
  // if (!showShareCheckbox) return null;

  return (
    <AnimatePresence>
      {makeReport && (
        <motion.div
          initial={{ opacity: 0, height: 0, marginTop: -12 }}
          animate={{ opacity: 1, height: "auto", marginTop: 0 }}
          exit={{ opacity: 0, height: 0, marginTop: -12 }}
        >
          <FnrEnrichedCheckbox
            on={share}
            toggleOn={() => setShare((share) => !share)}
            color="#00adbb"
          >
            {" "}
            Share with other admins
          </FnrEnrichedCheckbox>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
